import { STATI } from "./stati";

export function canCompile(status) {
  return status === STATI.compiled || status === STATI["awaiting compilation"];
}
